export default "data:video/mp2t;base64,ZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gKGFjY3VtdWxhdG9yOiBudW1iZXIsIGE6IG51bWJlcikgewogIHJldHVybiBhY2N1bXVsYXRvciArIGE7Cn0K"